// extracted by mini-css-extract-plugin
export var cardsSection = "R_cL";
export var loanCardList = "R_cJ";
export var titleSection = "R_cK";